import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isChecked: Boolean,
},
  emits: ["update:check"],
  setup(__props, { emit }) {



const checkLocal = (e: any) => {
  emit("update:check", e.target.checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: __props.isChecked,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (checkLocal($event)))
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}
}

})